import PermIdentity from '@material-ui/icons/PermIdentity';
import {CountriesList} from "./CountriesList";
import {CountriesCreate} from "./CountriesCreate";
import {CountriesEdit} from "./CountriesEdit";
// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: CountriesList,
    create: CountriesCreate,
    edit: CountriesEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;